import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { equals } from 'ramda';
import React from 'react';

import { Switch } from 'src/components/Switch/Switch';
import { TRUE } from 'src/constants';
import { NO_UPPERCASE_N, YES_UPPERCASE_Y } from 'src/services/constants';

interface Props {
  enableInAppNotification: string;
  handleChangeInAppNotification: (
    e: React.ChangeEvent<HTMLInputElement>,
  ) => void;
  isEdit: boolean;
}

export default function InAppNotificationToggle({
  enableInAppNotification,
  handleChangeInAppNotification,
  isEdit,
}: Props) {
  return isEdit ? (
    <Box
      mb={2}
      sx={{
        alignItems: 'center',
        display: 'flex',
      }}
    >
      <Box mt={1}>
        <Switch
          handleChange={handleChangeInAppNotification}
          isChecked={equals(enableInAppNotification,TRUE)}
        />
      </Box>
    </Box>
  ) : (
    <Grid container w-100>
      <Grid alignItems="center" display="flex" item xs={9}>
        <Typography
          sx={{
            fontSize: '14px',
            fontWeight: 600,
          }}
        >
          {enableInAppNotification === TRUE ? YES_UPPERCASE_Y : NO_UPPERCASE_N}
        </Typography>
      </Grid>
    </Grid>
  );
}
